import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import styles from "./LoyaltyContactFormCheckboxSection.module.scss";
export const LoyaltyContactFormCheckboxSection = ({ sectionName, sectionTitle, checkboxesData, required = false, validationErrorMessage, type = "multipleChoice", }) => {
    const { control, setValue, getValues, formState: { errors }, clearErrors, } = useFormContext();
    const isMultipleChoice = type === "multipleChoice";
    const isCheckboxError = Boolean(errors?.[sectionName]);
    const handleGetNewSectionValue = (isValueAvailable, answers) => {
        if (isValueAvailable) {
            return {
                question: sectionTitle,
                answers,
            };
        }
    };
    const handleMultipleChoiceSelection = ({ label, value }) => {
        const prevAnswers = getValues(sectionName)?.answers ?? [];
        const newAnswers = value ? [...prevAnswers, label] : prevAnswers.filter((item) => item !== label);
        return handleGetNewSectionValue(newAnswers.length > 0, newAnswers);
    };
    const handleSingleChoiceSelection = ({ label, value, name }) => {
        checkboxesData.forEach((item) => {
            if (item.name !== name) {
                setValue(item.name, { checked: false });
            }
        });
        return handleGetNewSectionValue(value, [label]);
    };
    const handleChangeValue = (checkboxData) => {
        clearErrors(sectionName);
        const getNewDataForSectionTitle = isMultipleChoice ? handleMultipleChoiceSelection : handleSingleChoiceSelection;
        const newSectionData = getNewDataForSectionTitle(checkboxData);
        setValue(sectionName, newSectionData);
    };
    return (_jsxs("div", { className: styles.container, children: [_jsx("h4", { className: styles.dialogTitle, children: sectionTitle }), _jsxs("div", { className: styles.checkboxesWrapper, children: [checkboxesData.map(({ label, name }) => (_jsx(Controller, { name: name, control: control, render: ({ field }) => (_jsx(Checkbox, { labelHtml: label, isError: isCheckboxError, ...field, onChange: (value) => {
                                field.onChange(value);
                                handleChangeValue({ label, value: value?.checked, name });
                            } }, label)) }, name))), isCheckboxError && (_jsxs("div", { className: styles.errorWrapper, children: [_jsx(UiWarningIcon, { className: styles.errorIcon }), _jsx("p", { className: styles.errorMessage, children: validationErrorMessage })] }))] }), _jsx(Controller, { name: sectionName, control: control, render: ({ field }) => _jsx("input", { type: "hidden", ...field }), rules: {
                    required: {
                        value: required,
                        message: validationErrorMessage,
                    },
                } })] }));
};
//# sourceMappingURL=LoyaltyContactFormCheckboxSection.js.map